import { IconComponent } from './types';

const DotMenuIcon: IconComponent = ({ className }) => {
  return (
    // Based on https://freesvg.org/menu-circles
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      height="12px"
      fill="currentColor"
      viewBox="0 0 16 70"
    >
      <g>
        <title>Layer 1</title>
        <g id="layer1">
          <g
            id="layer1-7"
            transform="matrix(0.105485 0 0 0.105485 -194.127 654.506)"
          >
            <g
              id="g3370"
              transform="matrix(10.414 0 0 10.414 -305.448 -41.831)"
            >
              <circle
                id="circle3352"
                r="7.131"
                cx="213.17878"
                cy="-584.66136"
              />
              <circle
                id="circle3356"
                r="7.131"
                cx="213.17878"
                cy="-559.98736"
              />
              <circle
                id="circle3360"
                r="7.131"
                cx="213.17878"
                cy="-535.17336"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DotMenuIcon;
